import React, { useEffect, useState } from "react";
import "./Orders.css";
import { Container, Button, Card, Col, Row, Form } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import { OrderDetailsByID } from "../../apis/OrderAPI";
import dateFormat from "dateformat";
import * as BsIcons from "react-icons/bs";
import { ShowOrderDocument } from "../../utils/Utility";

export default function Orders() {
  const [searchParams] = useSearchParams();
  const orderid = searchParams.get("id");
  const [orderdata, setOrderData] = useState([]);
  const [attachements, setAttachments] = useState([]);
  const [formDetail, setFormDetail] = useState([]);
  const [reports, setReports] = useState([]);
  const [reportAttachments, setReportAttachments] = useState([]);
  const [pdfReport, setPdfReport] = useState(false);
  const [primaryReportId, setPrimaryReportId] = useState(0);

  useEffect(() => {
    async function GetOrderData() {
      var result = await OrderDetailsByID(orderid, "view");
      var data = result.data;
      setOrderData(data.item1);
      setReports(data.item3);
      var attachs = data.item4;
      setAttachments(attachs.filter((a) => a.attachment_type === "order"));
      setReportAttachments(
        attachs.filter((a) => a.attachment_type === "report")
      );
      setFormDetail(data.item5);
      const rpt = data.item3.filter((rpt) => rpt.is_primary);
      if (rpt.length > 0) {
        if (rpt[0].template_name.includes("Pdf Reports")) setPdfReport(true);
        setPrimaryReportId(rpt[0].order_report_mapping_id);
      }
      if(data.item3.length === 1){
        if(data.item3[0].template_name.includes("Pdf Reports")) setPdfReport(true);
      }
    }
    GetOrderData();
  }, [orderid]);

  return (
    <>
      <Container className="mb-5">
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title"></div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter"></div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card className="orderdetails-card">
              <div className="card-head">
                <div className="card-title h5">
                  Order No: <span>{orderdata.order_id}</span>
                </div>
                <Link to="/Customer/Orders" className="back-btn">
                  <BsIcons.BsArrowLeft />
                </Link>
              </div>
              <Row>
                <Col lg={6} md={12}>
                  <div className="orderdetails-info">
                    <div className="orderdetails-info-list">
                      Status: <span>{orderdata.order_status_name}</span>
                    </div>
                    <div className="orderdetails-info-list">
                      Order Date:{" "}
                      <span>
                        {dateFormat(orderdata.order_start_date, "mm/dd/yyyy")}
                      </span>
                    </div>
                    <div className="orderdetails-info-list">
                      Order Address: <span>{orderdata.requestor_address}</span>
                    </div>
                    <div className="orderdetails-info-list">
                      Applicant: <span>{orderdata.order_applicant_name}</span>
                    </div>
                    <div className="orderdetails-info-list">
                      Address: <span>{orderdata.order_address}</span>
                    </div>
                    <div className="orderdetails-info-list">
                      Due Date:{" "}
                      <span>
                        {dateFormat(orderdata.order_end_date, "mm/dd/yyyy")}
                      </span>
                    </div>
                    <div className="orderdetails-info-list">
                      Prelim Report Date:{" "}
                      <span>
                        {!orderdata ||
                        !orderdata.order_prelim_report_date ||
                        orderdata.order_prelim_report_date.indexOf("1753") != -1
                          ? ""
                          : orderdata.order_prelim_report_date}
                      </span>
                    </div>
                    <div className="orderdetails-info-list">
                      Completion Date:{" "}
                      <span>
                        {!orderdata || !orderdata.order_completion_date
                          ? ""
                          : orderdata.order_completion_date.substring(
                              0,
                              orderdata.order_completion_date.indexOf("T")
                            )}
                      </span>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={12}>
                  <div className="orderdetails-info">
                    <div className="orderdetails-info-list">
                      Report Type:{" "}
                      {reports.length > 0 &&
                        reports.map((item, i) => (
                          <p key={i}>
                            <span>{item.report_name}</span>
                          </p>
                        ))}
                    </div>
                    <div className="orderdetails-info-list">
                      Report For:{" "}
                      <div className="chkbx">
                        <Form.Group controlId="ReportFor" className="mb-3">
                          <Form.Check
                            type="checkbox"
                            inline
                            label="Individual"
                            value="individual"
                            checked={orderdata.individual}
                            disabled
                          />
                          <Form.Check
                            type="checkbox"
                            inline
                            label="Corporate"
                            value="corporate"
                            checked={orderdata.corporate}
                            disabled
                          />
                          <Form.Check
                            type="checkbox"
                            inline
                            label="Other"
                            value="other"
                            checked={orderdata.other}
                            disabled
                          />
                          {orderdata.other && (
                            <p>
                              <span>Report Remark:</span>
                              {orderdata.other_text}
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                    <div className="orderdetails-info-list">
                      Other Instructions:{" "}
                      <span>{orderdata.order_customer_instruction}</span>
                    </div>
                    <div className="orderdetails-info-list">
                      Form(s):{" "}
                      {formDetail.map((item) => (
                        <p>
                          <span>
                            <Link
                              to={`/Form?token=view&id=${item.form_id}&applicationid=${item.application_id}`}
                            >
                              {item.form_name}
                            </Link>
                          </span>
                        </p>
                      ))}
                    </div>
                    <div className="orderdetails-info-list">
                      Attachment(s):{" "}
                      {attachements.map((item, i) => (
                        <p key={i}>
                          <span>
                            <Link
                              to={`?id=${orderid}`}
                              onClick={() =>
                                ShowOrderDocument(item.order_attachment_id)
                              }
                            >
                              {item.attachment_name}
                            </Link>
                          </span>
                        </p>
                      ))}
                    </div>
                    <div className="orderdetails-info-list">
                      Report Attachment(s):{" "}
                      {reportAttachments.map((item) => (
                        <p>
                          <span>
                            <Link
                              to={`?id=${orderid}`}
                              onClick={() =>
                                ShowOrderDocument(item.order_attachment_id)
                              }
                            >
                              {item.attachment_name}
                            </Link>
                          </span>
                        </p>
                      ))}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className={!pdfReport ? "text-center mt-5" : "no-display"}>
                  <Button
                    type="button"
                    className="view-report-btn"
                    disabled={
                      primaryReportId === 0 ||
                      (orderdata.order_status_id !== 3 &&
                        orderdata.order_status_id !== 4 &&
                        orderdata.order_status_id !== 5 &&
                        orderdata.order_status_id !== 7)
                        ? true
                        : false
                    }
                    onClick={() =>
                      window.open(
                        "/Report?type=view&id=" + primaryReportId,
                        "_blank"
                      )
                    }
                  >
                    View Report
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
